import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { hotlineProDetailMeetingHistoryListStyle } from '@/feature/hotline/professional/detail/meeting/component/HotlineProDetailMeetingHistoryList/style';
import { formatDateToFixedTimeText } from '@/feature/hotline/util/formatDate';
/**
 * 匿名ホットライン 面談履歴一覧
 */
export const HotlineProDetailMeetingHistoryList = (props) => {
    const { className = '', completedRequestInterviews } = props;
    const style = hotlineProDetailMeetingHistoryListStyle();
    if (!completedRequestInterviews.length) {
        return _jsx("p", Object.assign({ className: style.noDataBase() }, { children: "\u8868\u793A\u3067\u304D\u308B\u76F8\u8AC7\u5C65\u6B74\u306F\u3042\u308A\u307E\u305B\u3093" }));
    }
    return (_jsx("ul", Object.assign({ className: style.list({ class: className }) }, { children: completedRequestInterviews.map((completedRequestInterview) => (_jsx("li", Object.assign({ className: style.item() }, { children: formatDateToFixedTimeText(completedRequestInterview.interviewed_from_at, completedRequestInterview.interviewed_to_at) }), completedRequestInterview.id))) })));
};
